import type { Step } from 'react-joyride';

export const policyEditTourSteps: Step[] = [
    {
        target: 'body',
        content: 'ໜ້າແກ້ໄຂນະໂຍບາຍ: ອັບເດດຂໍ້ມູນ ແລະ ເນື້ອໃນຂອງນະໂຍບາຍທີ່ມີຢູ່.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-edit-back"]',
        content: 'ສ່ວນຫົວໜ້າ: ມີປຸ່ມກັບໄປລາຍການ ແລະ ປຸ່ມເລີ່ມທົດສອບ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-edit-form"]',
        content: 'ຟອມແກ້ໄຂ: ປັບປຸງຂໍ້ມູນ ແລະ ບັນທຶກການປ່ຽນແປງ.',
        placement: 'top',
    },
];
